module.exports = __webpack_public_path__ + "static/img/blue.ed584146.png";